import { Email } from "./entity";
import DtoList from "../../base_classes/dto_list";
import { type JSONData } from "../../base_classes/dto.d";
import { type IEmailList } from "./list.gen.d";
import { Pagination } from "../../base_classes/pagination";
import { Query } from "../../base_classes/query";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

export class EmailList extends DtoList implements IEmailList {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/email";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////
  list: Email[] = [];
  queriedList: Email[] = [];

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  _buildInstance(data: JSONData): Email {
    return new Email([], data);
  }

  override async getAll(
    pathVars?: string | string[] | Record<string, string>,
  ): Promise<Email[]> {
    return (await super.getAll(pathVars)) as Email[];
  }

  override async getPaginated(
    pathVars: string | string[],
    pagination: Pagination,
  ): Promise<{
    items: Email[];
    pagination: Pagination;
  }> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return (await super.getPaginated(pathVars, pagination)) as {
      items: Email[];
      pagination: Pagination;
    };
  }

  override async query(
    queries: Query[],
    pagination?: Pagination,
  ): Promise<{
    items: Email[];
    pagination: Pagination;
  }> {
    return (await super.query(queries, pagination)) as {
      items: Email[];
      pagination: Pagination;
    };
  }

  override async search(
    query: string,
    pagination?: Pagination,
  ): Promise<{
    items: Email[];
    pagination: Pagination;
  }> {
    return (await super.search(query, pagination)) as {
      items: Email[];
      pagination: Pagination;
    };
  }
}
